<template>
  <div id="app" @click="fadeThat">
    <transition name="fade" mode="out-in" v-on:enter="enter" v-on:leave="leave">
    <keep-alive include="Home">
      <router-view/> 
    </keep-alive>
   </transition>
      
  </div>
</template>

<script>
import * as Api from './api/apies6.js';
window.axios = require('axios');
export default {
  name: 'app',
  methods:{
        leave(e){
             if(!e.className.includes('btn-read-recommend-dialog')){
                $('#app').css({'transition':'transform 1s ease', 'transform':'scale(1.2)'});
            }
        },
        enter(el){
            $('#app').css('transform','none');
        },
        fadeThat:function(e){
          if(e.target.tagName == 'A' && !e.target.className.includes('btn-social') && !e.target.className.includes('btn-read-recommend-dialog') && !e.target.className.includes('no-fadeout')){
            $('#app').css({'transition':'transform 1s ease', 'transform':'scale(1.2)'});
          }
        }
  },
  async created() {
        let restoreToken = this.$route.query.rt
        let timeres = this.$route.query.timeres
        if((restoreToken !== null || typeof restoreToken == 'undefined') && (timeres !== null || typeof timeres == 'undefined')){
            this.feedBackReadProgress();
        }
      }
    }
</script>

<style>
    .fade-enter-active, .fade-leave-active {
        transition: opacity 1s ease, transform 1s ease;
    }
    .fade-enter, .fade-leave-to{
      opacity: 0;
    }

</style>



// WEBPACK FOOTER //
// src/App.vue